import React, { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { DataTableHeader } from '../../../components/DataTable/types';
import TransactionsHeaderLayout from './TransactionsHeaderLayout';

interface TransactionsTableHeaderProps {
  title?: string;
  headers: DataTableHeader[];
  totals: Record<string, ReactNode>;
  leftContent?: ReactNode;
  hasTrailingSpacer?: boolean;
}

const TransactionsTableHeader: React.FC<TransactionsTableHeaderProps> = ({
  title = 'Transaction history',
  headers,
  totals,
  leftContent,
  hasTrailingSpacer = false,
}) => {
  return (
    <Box sx={{ display: 'grid', mb: 3 }}>
      <Box sx={{ gridArea: '1/1', zIndex: 1, width: 'fit-content' }}>
        <Stack direction='column'>
          <Typography variant='p24' color='secondary.main'>
            {title}
          </Typography>
          {leftContent}
        </Stack>
      </Box>
      <Box sx={{ gridArea: '1/1', zIndex: 0 }}>
        <TransactionsHeaderLayout
          headers={headers}
          totals={totals}
          hasLeadingColumn={true}
          hasTrailingSpacer={hasTrailingSpacer}
        />
      </Box>
    </Box>
  );
};

export default TransactionsTableHeader;
